import { render, staticRenderFns } from "./DepositGroup.vue?vue&type=template&id=299d10c4&scoped=true&"
import script from "./DepositGroup.vue?vue&type=script&lang=js&"
export * from "./DepositGroup.vue?vue&type=script&lang=js&"
import style0 from "./DepositGroup.vue?vue&type=style&index=0&id=299d10c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d10c4",
  null
  
)

export default component.exports